var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`dot${_vm.pulse ? ' pulse' : ''}`,style:({backgroundColor: _vm.hex || _vm.$colors[_vm.variant]})})
}
var staticRenderFns = []

export { render, staticRenderFns }